<main>
  <div class="container dark-grey-text mt-5">
    <b-overlay :show="isLoading" rounded="sm">
      <div class="row wow fadeIn">
        <div class="col-md-3 mb-4">
          <img v-if="product.iconImg" class="img-fluid img-thumbnail" :src="product.iconImg" :alt="product.text" />
        </div>
        <div class="col-md-9 mb-4">
          <h2>{{ product.text }}</h2>
          <div class="p-1">
            <form id="groceryForm" @submit.prevent="CheckOutProduct">
              <!-- Pick Up Name -->
              <div class="form-group">
                <label class="font-weight-bold">Pick Up Name</label>
                <input
                  v-model="pickUpName"
                  type="text"
                  class="form-control"
                  placeholder="Enter pick up name"
                  required
                />
                <small v-if="pickUpNameError" class="text-warning">{{ pickUpNameError }}</small>
              </div>

              <!-- Pick Up Surname -->
              <div class="form-group">
                <label class="font-weight-bold">Pick Up Surname</label>
                <input
                  v-model="pickUpSurname"
                  type="text"
                  class="form-control"
                  placeholder="Enter pick up surname"
                  required
                />
                <small v-if="pickUpSurnameError" class="text-warning">{{ pickUpSurnameError }}</small>
              </div>

              <!-- Pick Up Number (ZW validation) -->
              <div class="form-group">
                <label class="font-weight-bold">Pick Up Number</label>
                <vue-phone-number-input
                  id="pickUpNumber"
                  v-model="pickUpNumber"
                  default-country-code="ZW"
                  :only-countries="['ZW']"
                  no-example
                  required
                  size="lg"
                  maxlength="12"
                  @update="ValidatePickUpNumber"
                />
                <div><span class="text-warning">{{ pickUpNumberError }}</span></div>
              </div>

              <!-- Amount selector -->
              <div class="form-group">
                <label class="font-weight-bold">Amount</label>
                <select v-model="selectedProduct" required class="form-control">
                  <option v-for="(value, name, index) in priceList.productList" :value="value" :key="name">
                    {{ value.description }} - ZAR {{ value.totalAmount }}
                  </option>
                </select>
              </div>

              <br />
              <base-button class="btn-3" type="primary" @click="CheckOutProduct" icon="ni ni-credit-card">
                Proceed to payment
              </base-button>
            </form>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</main>
